import en from "../locales/en/translation.json";
import fr from "../locales/fr/translation.json";

export const DEFAULT_LANG = "en";

export const SUPPORTED_LANGS = ["en", "fr"];

export const RESOURCES = {
  en: { translation: en },
  fr: { translation: fr },
};
